var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c(
        "v-app",
        [
          _vm.externalView
            ? _c(
                "div",
                [
                  _c("router-view", {
                    key: _vm.$route.name,
                    attrs: { name: "external" }
                  })
                ],
                1
              )
            : _vm.inAppView
              ? _c("div", [
                  _c("div", { staticClass: "pages" }, [
                    _vm.app.ready
                      ? _c(
                          "div",
                          { staticClass: "page-content" },
                          [
                            _c("router-view", {
                              key: _vm.$route.name,
                              attrs: { name: "app" }
                            })
                          ],
                          1
                        )
                      : _c("div", { staticClass: "page-content" }, [
                          _c(
                            "div",
                            { staticClass: "center-parent" },
                            [
                              _c("v-progress-circular", {
                                staticStyle: { margin: "0 auto" },
                                attrs: {
                                  indeterminate: "",
                                  color: "accent",
                                  size: 80
                                }
                              })
                            ],
                            1
                          )
                        ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "navigation" }, [
                    _c(
                      "div",
                      { staticClass: "desktop-nav" },
                      [_c("vo-navigation")],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "mobile-nav" },
                      [_c("vo-navigation-mobile")],
                      1
                    )
                  ])
                ])
              : _c("div", [
                  _c(
                    "div",
                    { staticClass: "center-parent" },
                    [
                      _c("v-progress-circular", {
                        staticStyle: { margin: "0 auto" },
                        attrs: { indeterminate: "", color: "accent", size: 80 }
                      })
                    ],
                    1
                  )
                ]),
          _vm._v(" "),
          _c("vo-dialog-parent", {
            attrs: { dialogComponent: _vm.$route.query.dialog }
          }),
          _vm._v(" "),
          _c("vo-gallery"),
          _vm._v(" "),
          _c("vo-dialog"),
          _vm._v(" "),
          _c("vo-toast"),
          _vm._v(" "),
          _c("vo-activity-toast"),
          _vm._v(" "),
          _vm.app.versionLockout ? _c("vo-version-lockout") : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-617ab0be", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-617ab0be","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 437
// module chunks = 4